module.exports = __webpack_public_path__ + "img/ico_zhuanlan.782f3e47.png";